import React from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from 'src/components/ui/Icon/Icon';
import TopBar from 'src/components/ui/TopBar/TopBar';
import Divider from 'src/components/ui/Divider/Divider';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import styles from '../styles/LoginAndRegister.module.scss';
import { RegistrationStatus } from './schema';

interface RegistrationLockedViewProps {
  status: RegistrationStatus;
}

const RegistrationLockedView: React.FC<RegistrationLockedViewProps> = ({ status }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const titleKey = `registration.locked.${status}_title`;
  const copyKey = `registration.locked.${status}_copy`;

  return (
    <div className={classNames(styles.root)}>
      <div className={styles.topbar}>
        <TopBar onClick={() => navigate('/login')} />
      </div>
      <div className={styles.main}>
        <div className={styles.content}>
          <div className="relative w-full px-20 md:px-64 py-32 md:py-48 flex-1 flex flex-col">
            <div className="mb-32">
              <h2 className="typo-title-36 text-full mb-12">{t(titleKey)}</h2>
              <span className="typo-title-24 text-faded">{t(copyKey)}</span>
            </div>
            <Divider customColor="border-subtle" className="mb-32" />
            <Button
              title={t('onboarding.log_in')}
              tone={ButtonToneProps.SECONDARY}
              onClick={() => navigate('/login')}
            />
            <span className="w-full inline-block typo-text-14 text-faded text-center mt-auto pt-32">
              {new Date().getFullYear()} {t('general.all_rights_reserved')}
            </span>
          </div>
        </div>
        <div className={classNames(styles.image, 'md:w-1/2 flex justify-center items-center')}>
          <div className={styles.hero} aria-hidden />
          <Icon className={styles.icon} name="logo-full-white" width={91} height={30} />
        </div>
      </div>
    </div>
  );
};

export default RegistrationLockedView;
